import React from "react";

const JobOpening = ({ title, eligibility, applyLink }) => (
  <div className="col-md-6">
    <div className="job-opening">
      <h3>{title}</h3>
      <h4>Eligibility:</h4>
      <ul>
        {eligibility.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <a
        href={applyLink}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-custom btn-sm"
      >
        Apply Now
      </a>
    </div>
  </div>
);

export const Career = () => {
  const jobs = [
    {
      title: "Business Development Executive",
      eligibility: [
        "Bachelor's degree in Business, Marketing, or a related field.",
        "Proven experience in business development, sales, or a similar role.",
        "Excellent communication and negotiation skills.",
        "Ability to build and maintain client relationships.",
      ],
      applyLink: "https://forms.gle/QHaj1SQzKb7cgjEP7", 
    },
    {
      title: "Software Engineer",
      eligibility: [
        "Bachelor's degree in Computer Science or a related field.",
        "Proficiency in JavaScript, React, and Node.js.",
        "Experience with RESTful APIs and database technologies.",
        "Strong problem-solving skills.",
      ],
      applyLink: "https://forms.gle/MiLRgPYu5asnvwZt8",
    },
  ];

  return (
    <div id="career" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Join Our Team</h2>
          <p>We are looking for talented individuals to grow with us.</p>
        </div>
        <div className="row">
          {jobs.map((job, index) => (
            <JobOpening key={index} {...job} />
          ))}
        </div>
      </div>
    </div>
  );
};